const BaseComponent = require('common/home/view');
class HNHome extends BaseComponent {}

module.exports = HNHome;
